import { Col, Row } from '@/app/components/Flex/Flex'
import { Link } from '@/app/components/Link/Link'
import { Num } from '@/app/components/Num/Num'
import { Text } from '@/app/components/Text/Text'
import { UI } from '@/app/components/UI/UI'
import { type FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const ArcanaFooter: FunctionalComponent<{
  title: string
  items: {
    id: number
    name: string
    href: string
  }[]
  allLink: {
    href: string
    text: string
  }
  relatedLinks?: {
    title: string
    items: {
      href: string
      text: string
    }[]
  }
}> = props => {
  return (
    <UI.Panel class={styles.root}>
      <Row gap={30}>
        <Row gap={10}>
          <Text
            fontSize={16}
            fontWeight={600}
            as='h3'
          >
            {props.title}
          </Text>

          <ul class={styles.list}>
            {props.items.map(arcana => (
              <Col
                as='li'
                key={arcana.id}
              >
                <Link
                  class='ghost-link'
                  to={arcana.href}
                >
                  <Col
                    gap={5}
                    as='span'
                    alignItems='center'
                  >
                    <Num>{arcana.id}</Num>
                    <Text
                      as='span'
                      fontSize={16}
                    >
                      <span class='thin-link'>
                        {arcana.name}
                      </span>
                    </Text>
                  </Col>
                </Link>
              </Col>
            ))}
          </ul>

          <Text fontSize={16}>
            <Link
              class='thin-link'
              to={props.allLink.href}
            >
              {props.allLink.text}
            </Link>
          </Text>
        </Row>

        <Row gap={15}>
          {props.relatedLinks && (
            <Row gap={10}>
              <Text
                fontSize={16}
                fontWeight={600}
                as='h3'
              >
                {props.relatedLinks.title}
              </Text>

              <ul class={styles.relatedList}>
                {props.relatedLinks.items.map(item => (
                  <li key={item.href}>
                    <Text fontSize={16}>
                      <Link
                        class='thin-link'
                        to={item.href}
                      >
                        {item.text}
                      </Link>
                    </Text>
                  </li>
                ))}
              </ul>
            </Row>
          )}
        </Row>
      </Row>
    </UI.Panel>
  )
}
